import React, { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function MapScene({
  scale = [7, 7, 7],
  position = [0, -1, 0],
  rotation = [0, 0, 0],
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/map/map_scene.glb");
  const mapScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    mapScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [mapScene]);

  return (
    <RigidBody type="fixed" colliders="trimesh" position={position} rotation={rotation} {...rigidBodyProps}>
      <group scale={scale}>
        <primitive object={mapScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/map/map_scene.glb");
